import React from 'react';
import PropTypes from 'prop-types';

import { ErrorAlert, FormBody, Loader, Modal, ThemeContextProvider } from '@huggg/react-components';

import styles from "./prepaidCard.module.scss";

import dictionary from 'config/dictionary';

const reportMisuseModelLoader = () => ({
  markdown: {
    bulletAsset: 'https://cdn.huggg.me/icons/Alert.svg'
  },
  typography: {
    Heading_3: {
      color: '#F15E40',
    },
  }
});

const ReportMisuseModal = ({ isLoading, error, onClose, reportMisuse }) => {
  const onConfirm = () => reportMisuse('compromised');

  return (
    <Modal title={dictionary.prepaidCards.labels.reportMisuseTitle} onClose={onClose} className={styles.reportMisuseModal}>
      {isLoading && <Loader />}
      {!isLoading && <>
        <div className={styles.reportMisuseModalContent}>
          <div className={styles.reportMisuseFormContainer}>
            <ThemeContextProvider theme="misuse" modelLoader={reportMisuseModelLoader}>
              <FormBody
                buttonCopy={dictionary.prepaidCards.labels.reportMisuseButton}
                model={[
                  {
                    elementType: 'checkbox',
                    name: 'disclaimer',
                    placeholder: dictionary.prepaidCards.labels.reportMisuseDisclaimer,
                  },
                  {
                    elementType: 'markdown',
                    name: 'markdown',
                    placeholder: dictionary.prepaidCards.labels.cancelWarningMarkdown
                  },
                ]}
                onConfirm={onConfirm}
              />
            </ThemeContextProvider>
          </div>
        </div>
      </>}
      {error && <div className={styles.reportMisuseErrorContainer}><ErrorAlert message={dictionary.prepaidCards.errors.reportMisuse} /></div>}
    </Modal>
  );
};

ReportMisuseModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  reportMisuse: PropTypes.func.isRequired,
  error: PropTypes.object,
};

export default ReportMisuseModal;
